import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Dispatch } from '@reduxjs/toolkit';

import {
  MENU_ITEM_TYPE,
  TournamentMenuItem as TournamentMenuItemEntry,
} from 'app/modules/Navigation/types';
import type { ReduxState } from 'app/redux/types';

import { isFavoriteTournament } from 'app/lib/favorites/selectors';

import { createMenuItemTestDataAttributesGetter } from '../../test-data-helpers';
import LayerMenuItem from '../LayerMenuItem';

import styles from '../../styles/LeftMenu.module.scss';

const getMenuItemTestDataAttributes = createMenuItemTestDataAttributesGetter(
  'layer-menu-item',
  MENU_ITEM_TYPE.TOURNAMENT,
);

type SportTournamentMenuItemProps = {
  entry: TournamentMenuItemEntry;
  favorite: boolean;
  className?: string;
  dispatch: Dispatch;
};

const SportTournamentMenuItem: React.FC<SportTournamentMenuItemProps> = ({
  entry,
  favorite,
  className,
}) => {
  const layerMenuItemClassNames = classNames(
    styles.sportTournamentItem,
    className,
    { [styles.favorite]: favorite },
  );

  return (
    <LayerMenuItem
      entry={entry}
      className={layerMenuItemClassNames}
      testDataAttributes={getMenuItemTestDataAttributes(entry)} />
  );
};

const mapStateToProps = (
  state: ReduxState,
  { entry }: Pick<SportTournamentMenuItemProps, 'entry'>,
): Pick<SportTournamentMenuItemProps, 'favorite'> => ({
  favorite: isFavoriteTournament(state, entry.tournamentId),
});

export default connect(mapStateToProps)(SportTournamentMenuItem);
